import React, { useEffect, useState } from 'react';

function Header() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	const [skintype, setSkinType] = useState('');

	useEffect(() => {
		if(!userID || userID === '0'){
			window.location = '/';
		}
	},[]);

	useEffect(() =>{
		const skin = sessionStorage.getItem("skin") || 'light-skin';
		if(!skin || skin === 'light-skin'){
			document.body.classList.add('light-skin');
			document.body.classList.remove('dark-skin');
			setSkinType('light-skin');
		}else{
			document.body.classList.remove('light-skin');
			document.body.classList.add('dark-skin');
			setSkinType('dark-skin');
		}
		
	},[skintype]);

	const changeSkin = () => {
		const skin = sessionStorage.getItem("skin");
		if(!skin || skin === 'dark-skin'){
			sessionStorage.setItem("skin", 'light-skin');
			document.body.classList.remove('dark-skin');
			document.body.classList.add('light-skin');
			setSkinType('light-skin');
		}else{
			sessionStorage.setItem("skin", 'dark-skin');
			document.body.classList.remove('light-skin');
			document.body.classList.add('dark-skin');
			setSkinType('dark-skin');
		}
	};

	const logout = () => {
		sessionStorage.removeItem("TRCUserId");
		sessionStorage.removeItem("TRCUserEmail");
		sessionStorage.removeItem("TRCUserName");
		sessionStorage.removeItem("TRCUserPosition");
		sessionStorage.removeItem("TRCUserType");

		window.location = '/';
	};

return (
	<>
    <header class="main-header" style={{borderBottom: '3px solid #009563', height: '85px'}}>
		<div class="d-flex logo-box" style={{padding: '10px'}}>	
		
			<a href="/" class="logo">
				<img src="assets/images/logo-letter.png" alt="logo" height="60" />
			</a>	
			<button onClick={()=>changeSkin()} className='btn btn-sm btn-light d-lg-none'><i className={skintype === 'light-skin' ? 'fa fa-sun': 'fa fa-moon'}></i></button>

			<button onClick={() => window.history.back()} className='btn btn-outline d-lg-none' ><i className='fa fa-arrow-left'></i></button>
		</div>   
		
		<nav class="navbar navbar-static-top">
			<div class="app-menu">
				<ul class="header-megamenu nav">
					<li class="btn-group nav-item">
						<a href="#" class="waves-effect waves-light nav-link push-btn btn-primary-light" data-toggle="push-menu" role="button">
							<i data-feather="menu"></i>
							</a>
					</li>
					
					{/* <li class="btn-group d-lg-inline-flex d-none">
						<div class="app-menu">
							<div class="search-bx mx-5">
								<form>
									<div class="input-group">
										<input type="search" class="form-control" placeholder="Search" />
										<div class="input-group-append">
										<button class="btn" type="submit" id="button-addon3"><i class="icon-Search"><span class="path1"></span><span class="path2"></span></i></button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</li> */}
				</ul> 
			</div>
		
			<div class="navbar-custom-menu r-side">
				<ul class="nav navbar-nav">
				    <li className='d-lg-inline-flex'>
						<button onClick={()=>changeSkin()} className='btn btn-sm btn-light'><i className={skintype === 'light-skin' ? 'fa fa-sun': 'fa fa-moon'}></i></button>
					</li>
					<li class="dropdown user user-menu">
						<a href="#" class="waves-effect waves-light dropdown-toggle w-auto l-h-12 bg-transparent p-0 no-shadow" title="User" data-bs-toggle="modal" data-bs-target="#quick_user_toggle">
							<img src="assets/images/avatar/avatar-13.png" class="avatar rounded-circle bg-primary-light h-40 w-40" alt="" />
							<span style={{fontSize: '14px', fontWeight: 500, color: '#666', padding: '0px 10px'}}>{userName}</span>
						</a>
					</li>
					
					
			
				</ul>
			</div>
		</nav>
	</header>

	<div class="modal modal-right fade" id="quick_user_toggle" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content slim-scroll3">
				<div class="modal-body p-30 bg-white">
					<div class="d-flex align-items-center mb-15 justify-content-between pb-30">
						<h4 class="m-0">User Profile
							{/* <small class="text-fade fs-12 ms-5">12 messages</small> */}
						</h4>
						<a href="#" class="btn btn-icon btn-danger-light btn-sm no-shadow" data-bs-dismiss="modal">
							<span class="fa fa-close"></span>
						</a>
					</div>
				<div>
					<div class="d-flex flex-row">
						<div class=""><img src="assets/images/avatar/avatar-13.png" alt="user" class="rounded bg-danger-light w-150" width="100" /></div>
						<div class="ps-20">
							<h5 class="mb-0">{userName}</h5>
							<p class="my-5 text-fade">{userPosition}</p>
							<a href={`mailto:${userEmail}`}><span class="icon-Mail-notification me-5 text-success"><span class="path1"></span><span class="path2">{}</span></span>{userEmail}</a>
							
						</div>
						
					</div>
					
				</div>
					<div class="dropdown-divider my-30"></div>
					<div>
						<div class="d-flex align-items-center mb-30">
								<div class="me-15 bg-primary-light h-50 w-50 l-h-60 rounded text-center">
											<span class="icon-Library fs-24"><span class="path1"></span><span class="path2"></span></span>
								</div>
								<div class="d-flex flex-column fw-500">
										<a href="/" class="text-dark hover-primary mb-1 fs-16">My Profile</a>
										<span class="text-fade">Account settings and more</span>
								</div>
						</div>
						
						<div class="d-flex align-items-center mb-30">
								<div class="me-15 bg-success-light h-50 w-50 l-h-60 rounded text-center">
										<span class="icon-Group-chat fs-24"><span class="path1"></span><span class="path2"></span></span>
								</div>
								<div class="d-flex flex-column fw-500">
										<a class="text-dark hover-success mb-1 fs-16" onClick={logout}>Logout</a>
										<span class="text-fade">Sign out from Trucoo</span>
								</div>
						</div>
						
					</div>
					<div class="dropdown-divider my-30"></div>
					
					
	</div>
</div>
</div>
</div>
</>
);
}

export default Header;